import cn from "classnames"

import { Box, Dropdown, Text } from "ui-kit/components-branded/index"
import { Price, StrikeOutPrice } from "components"
import { useBookingContext } from "modules/Booking/BookingContext"
import { useGetServicePrice } from "modules/Booking/common/hooks"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import { DepositConfiguration } from "modules/Booking/common/interfaces"
import style from "modules/Booking/FormPage/components/Deposit/style.module.scss"
import { sessionNounDeclensionByNumeral } from "utils/infrastructure/wording-utils"

interface Props {
    deposits: DepositConfiguration[]
}

export function Deposit({ deposits }: Props) {
    const [
        { psy, selectDeposit, sessionType, currency, selectedDiscount },
        { setSelectDeposit, changeSessionType, setSelectedDiscount },
    ] = useBookingContext()
    const [price, , defaultPrice] = useGetServicePrice()

    const handleClickBox = () => {
        changeSessionType(SESSION_TYPE.DEPOSIT)
        setSelectedDiscount(undefined)
        if (!selectDeposit) {
            setSelectDeposit(deposits[0])
        }
    }

    return (
        <Box
            className={cn(style.container, {
                [style.isActive]: sessionType === SESSION_TYPE.DEPOSIT,
            })}
            onClick={handleClickBox}
        >
            <div className={style.title}>Абонемент</div>
            <Dropdown
                label={
                    selectDeposit
                        ? `${selectDeposit.session_amount} ${sessionNounDeclensionByNumeral(selectDeposit.session_amount)}`
                        : `${deposits[0].session_amount} ${sessionNounDeclensionByNumeral(deposits[0].session_amount)}`
                }
                className={style.dropdown}
                triggerClassName={style.trigger}
            >
                {deposits.map((item) => {
                    return (
                        <Dropdown.Item onClick={() => setSelectDeposit(item)} key={item.id}>
                            {item.session_amount}{" "}
                            {sessionNounDeclensionByNumeral(item.session_amount)}
                        </Dropdown.Item>
                    )
                })}
            </Dropdown>
            <div className={style.footer}>
                <span className={style.badge}>
                    <span className={style.badgeContainer}>
                        -{selectDeposit ? selectDeposit.percentage : deposits[0].percentage}%
                    </span>
                </span>
                <Text className={cn(style.price, style.isNew)}>
                    <Price
                        psy={psy}
                        singleServicePrice={selectedDiscount ? price : defaultPrice}
                        currency={currency}
                        deposit={selectDeposit ? selectDeposit : deposits[0]}
                        singleDeposit
                        depositWithDiscount
                    />
                    &nbsp;за сессию &nbsp;
                </Text>
                <Text className={style.price}>
                    <Price
                        psy={psy}
                        singleServicePrice={selectedDiscount ? price : defaultPrice}
                        currency={currency}
                        className={style.oldPrice}
                        deposit={selectDeposit ? selectDeposit : deposits[0]}
                        singleDeposit
                    />
                    <StrikeOutPrice />
                </Text>
            </div>
        </Box>
    )
}
